var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"playWndBox",staticClass:"video_box",attrs:{"element-loading-background":"rgba(0, 0, 0, 0.2)"}},[_c('div',{staticClass:"playWnd",style:({ height: _vm.playWndHeight + 'px', width: _vm.playWndWidth + 'px' }),attrs:{"id":`playWnd`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }